import React, { Component } from 'react';
import './App.css';
import MenuBar from './MenuBar';
import Map from './Map';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { withAuth } from './AuthProvider';
import Login from './Login';

class App extends Component {
  constructor(props){
    super(props);
    console.log(props)
    this.state = { markers: [], metric: 'temperature' };
    this.setCity = this.setCity.bind(this);
    this.citynames = ['MelbourneLabel', 'PerthLabel', 'HoChiMinhLabel'];    
  }

  componentDidMount() {
    const mapboxgl = require('../node_modules/mapbox-gl/dist/mapbox-gl.js');
    mapboxgl.accessToken = 'pk.eyJ1IjoiZGFuaWVsYmV0dGVyaWRnZSIsImEiOiJjaWY3bjZqazcwc3IzczdrcmU1NjJ1czdnIn0.Xr0sZHMxs6Fvp7lzmmtJSg';
    
    let map = new mapboxgl.Map({
      container: 'map', // container id
      style: 'mapbox://styles/mapbox/dark-v9', // stylesheet location
      center: [115.8605, -31.9505], // starting position
      zoom: 13, // starting zoom
    });
    map.on('load', () => {
      map.addLayer({
        'id': '3d-buildings',
        'source': 'composite',
        'source-layer': 'building',
        'filter': ['==', 'extrude', 'true'],
        'type': 'fill-extrusion',
        'minzoom': 15,
        'paint': {
            'fill-extrusion-color': '#aaa',
            'fill-extrusion-height': {
                'type': 'identity',
                'property': 'height'
            },
            'fill-extrusion-base': {
                'type': 'identity',
                'property': 'min_height'
            },
            'fill-extrusion-opacity': .6
        }
      });
    })
    
    
    map.on('zoomend', () => {
      this.setState(() => {
        return { 'zoom': map.getZoom(), 'map': map, 'mapboxgl': mapboxgl }
      });
    });

    this.setState(()=>{
      return { "map": map,'startDate':null, 'endDate':null};
    },()=>{
      this.setCity(document.getElementsByClassName("Perth")[0].childNodes[0]);
    });

    
  }

  addDataPoints(json) {
    const readings = json.data.LiyuenReadings;
    this.setState((prevState, props) => {
      return { 'allreadings': readings, 'readings': readings };
    });
  }

  getMelbourne() {
    const headers = new Headers({'x-api-key': 'unyiUwlsYt2CA0vvCN1K44nu5f24JNQI7Oyuarzj'});
    this.setState(() => {
        return {loading: true };
      });
    fetch('https://api.sensing.city/prod/urbaniotapi?query=query%7B%0D%0A++LiyuenReadings%28%0D%0A++++maxX%3A+146%2C%0D%0A++++maxY%3A+-35%2C%0D%0A++++minX%3A+144%2C%0D%0A++++minY%3A+-39%2C%0D%0A++++first%3A+14000%2C%0D%0A++++offset%3A+0%2C%0D%0A++%29%7B%0D%0A++++deviceid%0D%0A++++lat%0D%0A++++long%0D%0A++++temperature%0D%0A++++humidity%0D%0A++++noise%0D%0A++++co%0D%0A++++lux%0D%0A++++objectemp%0D%0A++++time%0D%0A++++pm2%0D%0A++++wh%0D%0A++++wv%0D%0A++++pm3%0D%0A++%7D%0D%0A%7D', { headers:headers})
    .then((data) => {
      return data.json();
    })
    .then((json) => {   
      
      this.addDataPoints(json);   
      const map = this.state.map.jumpTo({ center: [144.9631, -37.8136] });
      this.setState(() => {
        return { 'map': map, loading: false };
      });
    });
    
  }

  getHoChiMinh() {
    const headers = new Headers({ 'x-api-key': 'unyiUwlsYt2CA0vvCN1K44nu5f24JNQI7Oyuarzj' });
    this.setState(() => {
        return { loading: true };
      });
    fetch('https://api.sensing.city/prod/urbaniotapi?query=query%7B%0D%0A++LiyuenReadings%28%0D%0A++++maxX%3A+107%2C%0D%0A++++maxY%3A+11%2C%0D%0A++++minX%3A+106%2C%0D%0A++++minY%3A+10%2C%0D%0A++++first%3A+2000%2C%0D%0A++++offset%3A+0%2C%0D%0A++%29%7B%0D%0A++++deviceid%0D%0A++++lat%0D%0A++++long%0D%0A++++temperature%0D%0A++++humidity%0D%0A++++noise%0D%0A++++co%0D%0A++++lux%0D%0A++++objectemp%0D%0A++++time%0D%0A++++pm3%0D%0A++%7D%0D%0A%7D', { headers:headers})
    .then((data) => {
      return data.json();
    })
    .then((json) => {  
      
      this.addDataPoints(json);
      const map = this.state.map.jumpTo({ center: [106.71, 10.79] });
      this.setState(() => {
        return { 'map': map, loading:false };
      });
    });
  }

  getPerth() {
    const headers = new Headers({ 'x-api-key': 'unyiUwlsYt2CA0vvCN1K44nu5f24JNQI7Oyuarzj' });
    this.setState(() => {
        return { loading: true };
      });
    fetch('https://api.sensing.city/prod/urbaniotapi?query=query%7B%0A%20%20LiyuenReadings(%0A%20%20%20%20maxX%3A%20116%2C%0A%20%20%20%20maxY%3A%20-31%2C%0A%20%20%20%20minX%3A%20115%2C%0A%20%20%20%20minY%3A%20-32%2C%0A%20%20%20%20first%3A+3000%2C%0D%0A++++offset%3A+0%2C%0D%0A++%29%7B%0D%0A++++deviceid%0D%0A++++lat%0D%0A++++long%0D%0A++++temperature%0D%0A++++humid%0D%0A++++noise%0D%0A++++co%0D%0A++++lux%0D%0A++++objectemp%0D%0A++++time%0D%0A++++pm2%0D%0A++++wh%0D%0A++++wv%0D%0A++++pm3%0D%0A++%7D%0D%0A%7D', { headers:headers})
    .then((data) => {
      return data.json();
    })
    .then((json) => {   
      
      this.addDataPoints(json);   
      const map = this.state.map.jumpTo({ center: [115.8605, -31.9505] })
      this.setState(() => {
        return { 'map':map, loading: false };
      });
    });
    
  }


  setCity(cityname) {
    let city = null;    
    if (cityname.innerHTML === 'Melbourne') {      
      city = 'Melbourne';
      this.getMelbourne();   
    } else if (cityname.innerHTML === 'Perth') {
      city = 'Perth';
      this.getPerth();
    } else if (cityname.innerHTML === 'HoChiMinh') {
      city = 'HoChiMinh';
      this.getHoChiMinh();
    }
    this.setState(() => {
      return { 'city': city, readings: null };
    });
    this.citynames.map((city) => {
      cityname.style['background-color'] = '#0e6c85';
      if (city !== cityname.className) {
        document.getElementsByClassName(city)[0].style['background-color'] = 'rgb(33, 34, 34)';
      }
    });
  }

  changeMetric(metric, element) {
    const children = Array.from(document.getElementsByClassName('overlay-metrics')[0].children);
    
    children.map((item) => {     
      if (item.className !== 'metric ' + metric && item.className !== 'metric-title') {      
        document.getElementsByClassName(item.className)[0].style['color'] = '#000';
        document.getElementsByClassName(item.className)[0].style['background-color'] = 'rgb(255,255,255)';
      } else {
        document.getElementsByClassName(item.className)[0].style['color'] = '#fff';
        document.getElementsByClassName(item.className)[0].style['background-color'] = '#418ac9';
      }
    })
    this.setState(() => {
      return { 'metric': metric };
    });
  }

  changeDates(){
    
    let updateddata = this.state.allreadings.filter((item)=>{
      let itemDate = moment(item.time); 
      if (itemDate < this.state.endDate && itemDate > this.state.startDate){
        return true;
      }
      return false;
    })
    this.setState(()=>{
      return {'readings': updateddata};
    })
   
  }

  render() {
    
    
    return (
      <div className="App">
        <MenuBar setCity={this.setCity} logout={this.props.auth.logout}/>
        
        <Map map={this.state.map} loading={this.state.loading} readings={this.state.readings} metric={this.state.metric} changeMetric={this.changeMetric.bind(this) } setCity={this.setCity.bind(this)} zoom={this.state.zoom} />
        {!this.state.loading && 
          <DateRangePicker
          isOutsideRange={()=>{return false}}
          startDate={this.state.startDate} // momentPropTypes.momentObj or null,
          endDate={this.state.endDate} // momentPropTypes.momentObj or null,
          onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate }, ()=>{this.changeDates()})} // PropTypes.func.isRequired,
          focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
          onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
        /> }
        
    </div>
    );
    
  }
}
const ShowPage = withAuth((auth) => auth.loggedIn ? <App auth={auth}/> : <Login auth={auth} />)
export default ShowPage;



// WEBPACK FOOTER //
// ./src/App.js